<script lang="ts">
  import { userbaseStore, LogStore, ArticleStore } from "../stores/stores";
  import Tabs from "../shared/Tabs.svelte";
  import Inventory from "./inventory/Inventory.svelte";
  import Logs from "./inventoryLogs/Logs.svelte";
  import ArticleList from "./articles/ArticleList.svelte";
  import { DatabaseName } from "../stores/types";
  import type { LogEntry, DBArticleEntry, Article } from "../stores/types";

  // tabs

  let items = Object.values(DatabaseName);
  let activeItem = DatabaseName.INVENTORY;
  const tabChange = (e) => {
    activeItem = e.detail;
  };

  let logs = [];
  let articles = [];

  LogStore.subscribe((value) => {
    logs = value;
  });

  ArticleStore.subscribe((value) => {
    articles = value;
  });

  const databaseNameLogs = DatabaseName.INVENTORYLOG.toString();

  function logChangeHandler(items: [LogEntry]) {
    logs = items;
    console.log(logs);
  }

  $: logPromise = $userbaseStore.openDatabase({
    databaseName: databaseNameLogs,
    changeHandler: logChangeHandler,
  });
</script>

<div class="maintab">
  <Tabs {activeItem} {items} on:tabChange={tabChange} />
  {#if activeItem === "inventory"}
    <Inventory />
  {:else if activeItem === "recipe"}
    <p>Hier kommen die Rezepte</p>
  {:else if activeItem === "logs"}
    <Logs {logs} />
  {:else if activeItem === "articles"}
    <ArticleList />
  {/if}
</div>

<style>
  .maintab {
    max-width: 1200px;
    margin: 40px auto;
  }
</style>
